import { getAuth } from "@react-native-firebase/auth";
import firestore from "@react-native-firebase/firestore";
import storage from "@react-native-firebase/storage";
import { Platform } from "react-native";

export { default as auth } from "@react-native-firebase/auth";
export { default as firestore } from "@react-native-firebase/firestore";
export { default as storage } from "@react-native-firebase/storage";

if (Platform.OS !== "web") {
  getAuth().setLanguageCode("es");
}

export const firestoreDoc = (ref: any, path: string) => {
  return firestore().doc(ref, path);
};

export const firestoreSetDoc = (docRef: any, data: any, options?: any) => {
  return firestore().setDoc(docRef, data, options);
};

